<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
        <path d="M6.91683 1.08301L1.0835 6.91634M1.0835 1.08301L6.91683 6.91634" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>